exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_object-gops.js
// module id = vSss
// module chunks = 1